import type { VisualElement } from "@judo/model-api";
import type { ModelRegistry } from "@judo/model-loader";

/**
 * Retrieve visual element by sourceId.
 * Note: This is a utility function, not a hook.
 * For reactive updates, use a context-based approach.
 *
 * @param registry - Model registry
 * @param sourceId - Source ID to find
 * @returns VisualElement or undefined
 */
export function getVisualElement(registry: ModelRegistry, sourceId: string): VisualElement | undefined {
	return registry.resolveVisualElement(sourceId);
}
